import { render, staticRenderFns } from "./ModalUpdateNhapVien.vue?vue&type=template&id=bd2ca738&scoped=true"
import script from "./ModalUpdateNhapVien.vue?vue&type=script&lang=js"
export * from "./ModalUpdateNhapVien.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdateNhapVien.vue?vue&type=style&index=0&id=bd2ca738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2ca738",
  null
  
)

export default component.exports